import { SurveyIcon } from '@m/alchemy-ui/icons/SurveyIcon';
import { GlobalIcon } from '@m/alchemy-ui/icons/GlobalIcon';
import { SettingsIcon } from '@m/alchemy-ui/icons/SettingsIcon';
import { VolumeIcon } from '@m/alchemy-ui/icons/VolumeIcon';
import { RibbonIcon } from '@m/alchemy-ui/icons/RibbonIcon';
import { TrendIcon } from '@m/alchemy-ui/icons/TrendIcon';
import { HealthCheckIcon } from '@m/alchemy-ui/icons/HealthCheckIcon';
import { CXProfilesIcon } from '@m/alchemy-ui/icons/CXProfilesIcon';
import { ChecklistIcon } from '@m/alchemy-ui/icons/ChecklistIcon';
import { TeamIcon } from '@m/alchemy-ui/icons/TeamIcon';
import { DataExportIcon } from '@m/alchemy-ui/icons/DataExportIcon';
import { IntegrationIcon } from '@m/alchemy-ui/icons/IntegrationIcon';
import { ExcludeIcon } from '@m/alchemy-ui/icons/ExcludeIcon';
import { ConfirmationIcon } from '@m/alchemy-ui/icons/ConfirmationIcon';

import * as React from 'react';

import { SettingsItemId } from 'settings/Settings.types';

const colors = {
  purple: '#6673d1',
  blue: '#348de6',
  orange: '#f8af48',
  cyan: '#01bcd5',
  lime: '#c3e634',
  green: '#76d63e',
  deepOrange: '#f76a3b',
  red: '#d51c26',
} as const;

type ShapeColor = typeof colors[keyof typeof colors];
type ShapeData = { icon: React.ReactNode; color: ShapeColor };

const defaultShape: ShapeData = {
  icon: <SettingsIcon aria-hidden="true" />,
  color: colors.blue,
};

const shapeById: { readonly [Key in SettingsItemId]?: ShapeData } = {
  company_info: {
    icon: <GlobalIcon aria-hidden="true" />,
    color: colors.purple,
  },
  survey_builder: {
    icon: <SurveyIcon aria-hidden="true" />,
    color: colors.green,
  },
  marketing: {
    icon: <VolumeIcon aria-hidden="true" />,
    color: colors.blue,
  },
  rewards: {
    icon: <RibbonIcon aria-hidden="true" />,
    color: colors.orange,
  },
  areas_of_improvement: {
    icon: <TrendIcon aria-hidden="true" />,
    color: colors.blue,
  },
  service_recovery: {
    icon: <HealthCheckIcon aria-hidden="true" />,
    color: colors.purple,
  },
  one_on_ones: {
    icon: <CXProfilesIcon aria-hidden="true" />,
    color: colors.cyan,
  },
  qa: {
    icon: <ChecklistIcon aria-hidden="true" />,
    color: colors.lime,
  },
  team: { icon: <TeamIcon aria-hidden="true" />, color: colors.green },
  exports: {
    icon: <DataExportIcon aria-hidden="true" />,
    color: colors.deepOrange,
  },
  integrations: {
    icon: <IntegrationIcon aria-hidden="true" />,
    color: colors.lime,
  },
  disable_company: {
    icon: <ExcludeIcon aria-hidden="true" />,
    color: colors.red,
  },
  enable_company: {
    icon: <ConfirmationIcon aria-hidden="true" />,
    color: colors.green,
  },
};

export function useDashboardItemsShapes(id: SettingsItemId): ShapeData {
  const resultShape = shapeById[id];

  if (resultShape === undefined) return defaultShape;
  return resultShape;
}
